function strtr(str, from, to) {
    //  discuss at: http://phpjs.org/functions/strtr/
    // original by: Brett Zamir (http://brett-zamir.me)
    //    input by: uestla
    //    input by: Alan C
    //    input by: Taras Bogach
    //    input by: jpfle
    // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  depends on: krsort
    //  depends on: ini_set
    //   example 1: $trans = {'hello' : 'hi', 'hi' : 'hello'};
    //   example 1: strtr('hi all, I said hello', $trans)
    //   returns 1: 'hello all, I said hi'
    //   example 2: strtr('�aaba�ccasde�oo', '���','aao');
    //   returns 2: 'aaabaaccasdeooo'
    //   example 3: strtr('��������', '�', 'a');
    //   returns 3: 'aaaaaaaa'
    //   example 4: strtr('http', 'pthxyz','xyzpth');
    //   returns 4: 'zyyx'
    //   example 5: strtr('zyyx', 'pthxyz','xyzpth');
    //   returns 5: 'http'
    //   example 6: strtr('aa', {'a':1,'aa':2});
    //   returns 6: '2'

    var fr = '',
        i = 0,
        j = 0,
        lenStr = 0,
        lenFrom = 0,
        tmpStrictForIn = false,
        fromTypeStr = '',
        toTypeStr = '',
        istr = '';
    var tmpFrom = [];
    var tmpTo = [];
    var ret = '';
    var match = false;

    // Received replace_pairs?
    // Convert to normal from->to chars
    if (typeof from === 'object') {
        tmpStrictForIn = this.ini_set('phpjs.strictForIn', false); // Not thread-safe; temporarily set to true
        from = this.krsort(from);
        this.ini_set('phpjs.strictForIn', tmpStrictForIn);

        for (fr in from) {
            if (from.hasOwnProperty(fr)) {
                tmpFrom.push(fr);
                tmpTo.push(from[fr]);
            }
        }

        from = tmpFrom;
        to = tmpTo;
    }

    // Walk through subject and replace chars when needed
    lenStr = str.length;
    lenFrom = from.length;
    fromTypeStr = typeof from === 'string';
    toTypeStr = typeof to === 'string';

    for (i = 0; i < lenStr; i++) {
        match = false;
        if (fromTypeStr) {
            istr = str.charAt(i);
            for (j = 0; j < lenFrom; j++) {
                if (istr == from.charAt(j)) {
                    match = true;
                    break;
                }
            }
        } else {
            for (j = 0; j < lenFrom; j++) {
                if (str.substr(i, from[j].length) == from[j]) {
                    match = true;
                    // Fast forward
                    i = (i + from[j].length) - 1;
                    break;
                }
            }
        }
        if (match) {
            ret += toTypeStr ? to.charAt(j) : to[j];
        } else {
            ret += str.charAt(i);
        }
    }

    return ret;
};

function krsort(inputArr, sort_flags) {
    //  discuss at: http://phpjs.org/functions/krsort/
    // original by: GeekFG (http://geekfg.blogspot.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: Brett Zamir (http://brett-zamir.me)
    //        note: The examples are correct, this is a new way
    //        note: This function deviates from PHP in returning a copy of the array instead
    //        note: of acting by reference and returning true; this was necessary because
    //        note: IE does not allow deleting and re-adding of properties without caching
    //        note: of property position; you can set the ini of "phpjs.strictForIn" to true to
    //        note: get the PHP behavior, but use this only if you are in an environment
    //        note: such as Firefox extensions where for-in iteration order is fixed and true
    //        note: property deletion is supported. Note that we intend to implement the PHP
    //        note: behavior by default if IE ever does allow it; only gives shallow copy since
    //        note: is by reference in PHP anyways
    //        note: Since JS objects' keys are always strings, and (the
    //        note: default) SORT_REGULAR flag distinguishes by key type,
    //        note: if the content is a numeric string, we treat the
    //        note: "original type" as numeric.
    //  depends on: i18n_loc_get_default
    //   example 1: data = {d: 'lemon', a: 'orange', b: 'banana', c: 'apple'};
    //   example 1: data = krsort(data);
    //   example 1: $result = data
    //   returns 1: {d: 'lemon', c: 'apple', b: 'banana', a: 'orange'}
    //   example 2: ini_set('phpjs.strictForIn', true);
    //   example 2: data = {2: 'van', 3: 'Zonneveld', 1: 'Kevin'};
    //   example 2: krsort(data);
    //   example 2: $result = data
    //   returns 2: {3: 'Kevin', 2: 'van', 1: 'Zonneveld'}

    var tmp_arr = {},
        keys = [],
        sorter, i, k, that = this,
        strictForIn = false,
        populateArr = {};

    switch (sort_flags) {
        case 'SORT_STRING':
            // compare items as strings
            sorter = function(a, b) {
                return that.strnatcmp(b, a);
            };
            break;
        case 'SORT_LOCALE_STRING':
            // compare items as strings, based on the current locale (set with  i18n_loc_set_default() as of PHP6)
            var loc = this.i18n_loc_get_default();
            sorter = this.php_js.i18nLocales[loc].sorting;
            break;
        case 'SORT_NUMERIC':
            // compare items numerically
            sorter = function(a, b) {
                return (b - a);
            };
            break;
        case 'SORT_REGULAR':
        // compare items normally (don't change types)
        default:
            sorter = function(b, a) {
                var aFloat = parseFloat(a),
                    bFloat = parseFloat(b),
                    aNumeric = aFloat + '' === a,
                    bNumeric = bFloat + '' === b;
                if (aNumeric && bNumeric) {
                    return aFloat > bFloat ? 1 : aFloat < bFloat ? -1 : 0;
                } else if (aNumeric && !bNumeric) {
                    return 1;
                } else if (!aNumeric && bNumeric) {
                    return -1;
                }
                return a > b ? 1 : a < b ? -1 : 0;
            };
            break;
    }

    // Make a list of key names
    for (k in inputArr) {
        if (inputArr.hasOwnProperty(k)) {
            keys.push(k);
        }
    }
    keys.sort(sorter);

    // BEGIN REDUNDANT
    this.php_js = this.php_js || {};
    this.php_js.ini = this.php_js.ini || {};
    // END REDUNDANT
    strictForIn = this.php_js.ini['phpjs.strictForIn'] && this.php_js.ini['phpjs.strictForIn'].local_value && this.php_js
            .ini['phpjs.strictForIn'].local_value !== 'off';
    populateArr = strictForIn ? inputArr : populateArr;

    // Rebuild array with sorted key names
    for (i = 0; i < keys.length; i++) {
        k = keys[i];
        tmp_arr[k] = inputArr[k];
        if (strictForIn) {
            delete inputArr[k];
        }
    }
    for (i in tmp_arr) {
        if (tmp_arr.hasOwnProperty(i)) {
            populateArr[i] = tmp_arr[i];
        }
    }

    return strictForIn || populateArr;
}

function i18n_loc_get_default() {
    //  discuss at: http://phpjs.org/functions/i18n_loc_get_default/
    // original by: Brett Zamir (http://brett-zamir.me)
    //        note: Renamed in PHP6 from locale_get_default(). Not listed yet at php.net
    //        note: List of locales at http://demo.icu-project.org/icu-bin/locexp
    //        note: To be usable with sort() if it is passed the SORT_LOCALE_STRING sorting flag: http://php.net/manual/en/function.sort.php
    //  depends on: i18n_loc_set_default
    //   example 1: i18n_loc_set_default('pt_PT');
    //   example 1: i18n_loc_get_default();
    //   returns 1: 'pt_PT'

    try {
        this.php_js = this.php_js || {};
    } catch (e) {
        this.php_js = {};
    }

    // Ensure defaults are set up
    return this.php_js.i18nLocale || (i18n_loc_set_default('en_US_POSIX'), 'en_US_POSIX');
}

function i18n_loc_set_default(name) {
    //  discuss at: http://phpjs.org/functions/i18n_loc_set_default/
    // original by: Brett Zamir (http://brett-zamir.me)
    //        note: Renamed in PHP6 from locale_set_default(). Not listed yet at php.net
    //        note: List of locales at http://demo.icu-project.org/icu-bin/locexp (use for implementing other locales here)
    //        note: To be usable with sort() if it is passed the SORT_LOCALE_STRING sorting flag: http://php.net/manual/en/function.sort.php
    //   example 1: i18n_loc_set_default('pt_PT');
    //   returns 1: true

    // BEGIN REDUNDANT
    this.php_js = this.php_js || {};
    // END REDUNDANT

    this.php_js.i18nLocales = {
        en_US_POSIX : {
            sorting : function(str1, str2) {
                // Fix: This one taken from strcmp, but need for other locales; we don't use localeCompare since its locale is not settable
                return (str1 == str2) ? 0 : ((str1 > str2) ? 1 : -1);
            }
        }
    };

    this.php_js.i18nLocale = name;
    return true;
}

function ini_set(varname, newvalue) {
    //  discuss at: http://phpjs.org/functions/ini_set/
    // original by: Brett Zamir (http://brett-zamir.me)
    //        note: This will not set a global_value or access level for the ini item
    //   example 1: ini_set('date.timezone', 'Asia/Hong_Kong');
    //   example 1: ini_set('date.timezone', 'America/Chicago');
    //   returns 1: 'Asia/Hong_Kong'

    var oldval = '';
    var self = this;

    try {
        this.php_js = this.php_js || {};
    } catch (e) {
        this.php_js = {};
    }

    this.php_js.ini = this.php_js.ini || {};
    this.php_js.ini[varname] = this.php_js.ini[varname] || {};

    oldval = this.php_js.ini[varname].local_value;

    var _setArr = function(oldval) {
        // Although these are set individually, they are all accumulated
        if (typeof oldval === 'undefined') {
            self.php_js.ini[varname].local_value = [];
        }
        self.php_js.ini[varname].local_value.push(newvalue);
    };

    switch (varname) {
        case 'extension':
            if (typeof this.dl === 'function') {
                // This function is only experimental in php.js
                this.dl(newvalue);
            }
            _setArr(oldval, newvalue);
            break;
        default:
            this.php_js.ini[varname].local_value = newvalue;
            break;
    }

    return oldval;
}

var Password = function()
{
    var $minimumLength = 10;

    var $commonPasswords = ['password','123456','12345678','1234','qwerty','12345'];

    function matchCommonPasswords($password)
    {
        $password = $password.toLowerCase();

        for (var $i = 0, $j = $commonPasswords.length; $i < $j; ++$i)
        {
            if ($password === $commonPasswords[$i] || $password.indexOf($commonPasswords[$i]) >= 0)
            {
                return $commonPasswords[$i];
            }
        }
    }

    function convertFromLeet($password)
    {
        var $mappings = {
            '@': 'a',
            '8': 'b',
            ')': 'd',
            '3': 'e',
            '6': 'g',
            '#': 'h',
            '1': 'i',
            ']': 'j',
            'X': 'l',
            'I': 'l',
            '|v|': 'm',
            '|\|': 'n',
            '0': 'o',
            '9': 'q',
            '5': 's',
            '7': 't',
            '\\/': 'v',
            'VV': 'w',
            '%': 'x',
            '2': 'z'
        };

        return strtr($password, $mappings);
    }

    function process(s, evaluator) {
        var h = Object.create(null), k;
        s.split('').forEach(function(c) {
            h[c] && h[c]++ || (h[c] = 1); });
        if (evaluator) for (k in h) evaluator(k, h[k]);
        return h;
    };

    this.entropy = function($password)
    {
        var sum = 0,len = $password.length;
        process($password, function(k, f) {
            var p = f/len;
            sum -= p * Math.log(p) / Math.log(2);
        });
        return sum;
    };

    this.bits = function($password)
    {
        return this.entropy($password) * $password.length;
    };

    this.check = function($password) {
        var $length = $password.length;
        var $entropy = this.entropy($password);

        if (!$entropy)
        {
            $entropy = 1;
        }


        // Get a multiplier for length checking the password
        var $lengthScoreMultiplier = $length >= $minimumLength ? 1 : 0;


        // Get all characters that repeat 3 or more times
        var $repeatedPatterns = $password.match(/(.+)\1{2,}/gi);


        // Find out if password is only alphabetic characters
        var $onlyAlpha = !!$password.match(/^[A-Za-z]+$/);


        // Get a common password it is matched to
        var $commonPassword = matchCommonPasswords($password);

        var $percentageOfCommon = 0;

        if ($commonPassword)
        {
            $percentageOfCommon = $commonPassword.length / $length;
        }

        // Check if deL33Ted version is common as well
        var $commonPasswordLeet = !$commonPassword ? matchCommonPasswords(convertFromLeet($password)) : null;

        var $strength = $length * $entropy;

        $strength *= $onlyAlpha ? 0.75 : 1;
        $strength *= $commonPassword ? 1 - (0.5 * $percentageOfCommon) : 1;
        $strength *= !$commonPassword && $commonPasswordLeet ? 0.85 : 1;

        for (var $x in $repeatedPatterns)
        {
            //$strength *= 0.90;
        }

        return $strength * $lengthScoreMultiplier;
    };

    this.examine = function($password)
    {
        var $strength = this.check($password);

        if ($strength >= 60)
        {
            return 'excellent';
        }

        if ($strength >= 40)
        {
            return 'great';
        }

        if ($strength >= 30)
        {
            return 'good';
        }

        if ($strength >= 20)
        {
            return 'bad'
        }

        return 'fail';
    }
};
